// Shared cookie name usable on both client and server
// Prefer NEXT_PUBLIC_ for client builds, fallback to server env, then default.
export const AUTH_COOKIE_NAME =
  process.env.NEXT_PUBLIC_AUTH_COOKIE_NAME || 'ua_token';

export const AUTH_USER_ID_COOKIE_NAME =
  process.env.NEXT_PUBLIC_AUTH_USER_ID_COOKIE_NAME || 'ua_user_id';
